/**
 * Converts a Date object to a time string in either 12-hour or 24-hour format.
 *
 * @param {Date} date - The Date object to be converted to a time string.
 * @param {boolean} useTwelveHourFormat - Whether to use a 12-hour format (true) or 24-hour format (false).
 * @returns {string} - The formatted time string in 12-hour or 24-hour format.
 *
 * @example
 * const time = dateToTime(new Date(), true);
 * console.log(time); // Output: "3:30" (if 12-hour format is used)
 *
 * @example
 * const time = dateToTime(new Date(), false);
 * console.log(time); // Output: "15:30" (if 24-hour format is used)
 */
export default function dateToTime(date, useTwelveHourFormat) {
  return date
    .toLocaleString(navigator.language, {
      hour: 'numeric',
      minute: 'numeric',
      hour12: useTwelveHourFormat,
    })
    .replace(/am|pm/gi, '')
    .trim();
}
